import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAuth } from '@/contexts/AuthContext'

export const Route = createFileRoute('/admin/')({
  component: () => {
    const { user } = useAuth()
    if (!user) return <Navigate to="/login" />
    return <Navigate to="/admin/dashboard" />
  },
})